<template>
  <div v-if="lesson" class="container">
    <article class="lesson_content" v-bind:style="{ 'background-image': 'url(/images/courses/' + lesson.course.id + '/lessons/' + lesson.id + '/' + lesson.image + ')' }">
      <div class="content_column">
        <div class="lesson_content__wrapper">
          <div class="lesson_content__course_title">{{ lesson.course.title }}</div>
          <h1 class="lesson_content__title">{{ $t('lesson') }} {{ lesson.innerId }}: {{ lesson.title }}</h1>
        </div>
        <content-editor v-model="lesson.text" :options="options" :controls="false"></content-editor>

        <div class="lesson_content__test test_block" v-if="tests && tests[0] && user">
          <p class="test_block__label">
            {{ $t('lesson_test_label') }}
          </p>
          <router-link :to="{ name: 'tests.view', params: {courseId: this.course.id, lessonId: lesson.id, id: tests[0].test_uuid}}"
                       class="test_block__button button button--blue button--uppercase">
            Пройти тест
          </router-link>
        </div>
      </div>

      <div class="course-lessons" v-if="course && course.lessons && course.lessons.length > 1">
        <h2 class="course-lessons__header">Другие занятия курса</h2>
        <div class="course-lessons__cards">
          <lesson-card :key="other_lesson.id" :lesson-id="other_lesson.id" :course-id="course.id" :lesson="other_lesson" v-for="(other_lesson, key) in course.lessons" v-if="lesson.id !== other_lesson.id"></lesson-card>
        </div>
      </div>
    </article>
  </div>
</template>.

<script>
  import { mapGetters } from 'vuex';
  import ContentEditor from '~/components/ContentEditor';
  import LessonCard from '~/components/LessonCard';

  export default {
    metaInfo () {
      return { title: this.lesson ? this.lesson.title : '' };
    },
    components: {
      ContentEditor,
      LessonCard
    },
    data: () => ({
      options: {
        postImageUrl: '',
        postFileUrl: '',
        baseImagePath: '',
        baseFilePath: '',
      },
    }),
    computed: mapGetters({
      user: 'auth/user',
      course: 'courses/course',
      lesson: 'lessons/lesson',
      tests: 'lessonTests/lessonTests',
    }),
    async beforeMount () {
      this.$store.dispatch('lessons/clearLesson');

      const courseId = this.$route.params.courseId;
      const lessonId = this.$route.params.id;

      this.options.postImageUrl = '/api/lessons/' + lessonId + '/images';
      this.options.postFileUrl = '/api/lessons/' + lessonId + '/files';
      this.options.baseImagePath = '/images/courses/' + courseId + '/lessons/' + lessonId;
      this.options.baseFilePath = '/files/courses/' + courseId + '/lessons/' + lessonId;

      const promise = Promise.all([
        this.$store.dispatch('courses/find', courseId),
        this.$store.dispatch('lessons/find', { courseId, lessonId }),
        this.$store.dispatch('lessonTests/fetchLessonTests', { lessonId }),
      ]);

      promise.then(() => {
        this.$store.dispatch('pages/stopLoading');
        this.$store.dispatch('pages/setBreadcrumbs', [
          {
            title: 'Главная',
            route: { name: 'home' },
          },
          {
            title: this.course.title,
            route: { name: 'course.view', params: { id: courseId }},
          },
          {
            title: this.lesson.title,
          }
        ]);
        this.$store.dispatch('pages/setControls', [
          {
            url: '/admin/courses/edit/' + courseId,
            label: 'Редактировать курс',
            roles: ['admin', 'curator', 'teacher']
          },
          {
            url: '/admin/courses/' + courseId + '/lessons/edit/' + lessonId,
            label: 'Редактировать занятие',
            roles: ['admin', 'curator', 'teacher']
          }
        ]);
      });
    }
  }
</script>
